import {
    Box,
    Container,
    Grid,
    Skeleton,
    ThemeProvider,
    createTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import DetailTemplateFinancial from "./DetailTemplateFinancial";
import NewTemplateInfo from "./newTemplateInfo";
import DetailLoanTemplate from "./DetailLoanTemplate";
import { getLoanTemplateCloneInfo } from "../../services/loanTemplate.service";
import { LoanTemplateIdRequest, LoanTemplateSpecification } from "../../models/loanTemplate.model";
import DetailTemplateGuarantee from "./DetailTemplateGuarantee";
import DetailTemplateDocumentType from "./DetailTemplateDocumentType";
import DetailTemplateInquiry from "./DetailTemplateInquiry";


const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1350,
            xl: 1536,
        },
    },
});


const LoanTemplateInfo = (props: any) => {
    const [cloneInfo, setCloneInfo] = useState<LoanTemplateSpecification>();
    const history = useHistory<any>();
    const id = localStorage.getItem("FinancialSupplier_ID");
    // history.location.state !== undefined ? history.location.state.id : null;

    const getLoanTemplateCloneInfoMutation = useMutation(getLoanTemplateCloneInfo, {
        onSuccess: (data: LoanTemplateSpecification) => {
            if (data) {
                setCloneInfo(data);
            }
        },
        onError: () => { },
    });

    useEffect(() => {
        let loanTemplateId = {} as LoanTemplateIdRequest;
        loanTemplateId.id = Number(id);
        getLoanTemplateCloneInfoMutation.mutate(loanTemplateId)
    }, [id]);

    useEffect(() => {
        if (history.action === "POP") {
            history.push({
                pathname: "/FinancialSupplier",
                state: { id: Number(id) },
            });
        }
    }, [history, id]);

    useEffect(() => {
        if (history.action === "POP") {
            history.push({
                pathname: "/FinancialSupplier1/FinancialSupplierDetailList",
                state: { id: Number(id) },
            });
            let loanTemplateId = {} as LoanTemplateIdRequest;
            loanTemplateId.id = Number(id);
            getLoanTemplateCloneInfoMutation.mutate(loanTemplateId)
        }
    });
    useEffect(() => {
        if (history.action === "POP") {
            history.push({
                pathname: "/FinancialSupplier1/FinancialSupplierDetailList",
                state: { id: Number(id) },
            });
        }
    }, [props.history]);


    return (
        <>
            {props?.history.location.state != undefined && props?.history.location.state != null ?
                <ThemeProvider theme={theme}>
                    <div>
                        {/* supplier card detail info */}
                        <Grid container marginBottom={"4rem"} xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                            <Grid item xs={12} >
                                <Box
                                    sx={{
                                        backgroundColor: "rgba(154,175,196,0.15)",
                                        borderRadius: "5px",
                                    }}
                                    paddingY={"1rem"}
                                >
                                    <Grid container justifyContent={"center"} alignItems={"center"}>
                                        <Grid item xs={2} md={2} sm={4} style={{ position: 'relative', maxWidth: 'fit-content', left: '1.5vh' }}>
                                            {props?.history?.location?.state?.props?.cardImage ?
                                                <img
                                                    className="activePlansCardImg"
                                                    src={`data:image/png;base64,${props?.history?.location?.state?.props?.cardImage!}`}
                                                    alt=""
                                                /> :
                                                <Skeleton
                                                    variant="rectangular"
                                                    width={140}
                                                    height={75}
                                                    animation={false}
                                                    sx={{
                                                        // marginLeft: "0.5rem",
                                                        borderRadius: "5px",
                                                    }}
                                                >
                                                </Skeleton>
                                            }
                                        </Grid>
                                        <Grid item xs={8} md={8} sm={4}>
                                            <span style={{ color: '#1D4A87', fontSize: '18px' }}>
                                                ایجاد طرح جدید بر مبنای "{props?.history.location.state.props?.loanTemplateTitle}"
                                            </span>
                                            <br />
                                            <span style={{
                                                backgroundColor: "#1D4A87", borderRadius: '3px', color: '#fff',
                                                paddingRight: '7px', paddingLeft: '7px', position: 'relative',
                                                top: '10px'
                                            }}>{props?.history.location.state.props?.financialSupplierTitle}</span>
                                        </Grid>
                                        <Grid item xs={2} md={2} sm={6}></Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '8.5vh' }}>
                            {cloneInfo && <NewTemplateInfo data={cloneInfo} loanTemplateId={props?.history.location.state.props?.loanTemplateId} />}
                        </Grid>
                        <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '5vh' }}>
                            <DetailLoanTemplate data={props?.history.location.state.props?.loanTemplateSpecification} />
                        </Grid>
                        {props?.history.location.state.props?.installmentSteps?.length! > 0 ?
                            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '5vh' }}>
                                <DetailTemplateFinancial title={"طول دوره بازپرداخت"} data={props?.history.location.state.props?.installmentSteps}
                                    cardImage={props?.history.location.state.props?.cardImage!} />
                            </Grid> : ""
                        }
                        {props?.history.location.state.props?.inquiryTypes?.length! > 0 ?
                            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '5vh' }}>
                                <DetailTemplateInquiry title={"لیست استعلام های مورد نیاز:"} data={props?.history.location.state.props?.inquiryTypes} />
                            </Grid> : ""
                        }
                        {props?.history.location.state.props?.loanTemplateGuaranteeType?.length! > 0 ?
                            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '5vh' }}>
                                <DetailTemplateGuarantee title={"ضمانت های طرح"} data={props?.history.location.state.props?.loanTemplateGuaranteeType} />
                            </Grid> : ""
                        }
                       
                        {props?.history.location.state.props?.documentTypes?.length! > 0 ?
                            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingBottom: '5vh' }}>
                                <DetailTemplateDocumentType title={"مستندات مورد نیاز"} data={props?.history.location.state.props?.documentTypes} />
                            </Grid> : ""
                        }
                    </div>
                </ThemeProvider>
                : ""}
        </>
    );
};

export default LoanTemplateInfo;
